export default __webpack_public_path__ + "static/media/fingerprint.ffb8e9f7.png";